import React, { useEffect, useRef } from 'react';
import { hot } from 'react-hot-loader';
import Hls from 'hls.js';

/* UTILS */
import { rootUrl, baseName } from '../../utils/string';

const VideoPlayer = ({ src, ...props }) => {
	const videoRef = useRef(null);

	useEffect(() => {
		const checkAndPlayVideo = async () => {
			const video = videoRef.current;

			try {
				// Check the availability of the optimized file
				let playbackUrl = `${rootUrl(src)}/hls-${baseName(src).replace(/\.(mp4|mov)/, '/master.m3u8')}`;
				const response = await fetch(playbackUrl, { method: 'HEAD' });
				const isOptimized = response.headers.get('x-optimized-version') === 'HLS';

				if (isOptimized && Hls.isSupported()) {
					// Play the HLS file using hls.js
					const hls = new Hls();
					hls.loadSource(playbackUrl);
					hls.attachMedia(video);
				} else {
					// Fallback to MP4 playback
					video.src = src;
					video.load();
				}
			} catch (error) {
				console.error('Error loading video:', error);
			}
		};

		checkAndPlayVideo();
	}, [src]);

	return (
		// eslint-disable-next-line jsx-a11y/media-has-caption
		<video ref={videoRef} {...props}>
			Your browser does not support the video tag.
		</video>
	);
};

export default hot(module)(VideoPlayer);
